export default __webpack_public_path__ + "static/media/landing_mat_detail_guard.68e8de79.png";